import { render, staticRenderFns } from "./blacklist-custom.vue?vue&type=template&id=c32a5afa&"
import script from "./blacklist-custom.vue?vue&type=script&lang=js&"
export * from "./blacklist-custom.vue?vue&type=script&lang=js&"
import style0 from "./blacklist-custom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports